module.exports = [{"aeroporto":{"label":"Bolzano","value":"BZO"},"dataOraArrivo":{"date":{"date":[19,9,25]},"time":{"time":[18,30]}},"dataOraPartenza":{"date":{"date":[19,9,25]},"time":{"time":[23,30]}},"terminalArrivo":"1","terminalPartenza":"B"}]


//////////////////
// WEBPACK FOOTER
// ./src/front/fake/scalo-tecnico.json
// module id = YB/8
// module chunks = 9